import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import BarChart from 'components/organisms/Charts/BarChart/BarChart';

const StyledAnalysisScoreBarChart = styled(BarChart)`
  &.BarChart {
    .BarChart-bar {
      &.hover {
        stroke: transparent;
        filter: unset;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledAnalysisScoreBarChart.propTypes = {
};

export default StyledAnalysisScoreBarChart;
